module.exports = __webpack_public_path__ + "static/img/a6.dfbced9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a6.png
// module id = 30
// module chunks = 1